export default __webpack_public_path__ + "static/media/INDUSTRIES.60e14640.png";